import { render, staticRenderFns } from "./PptShape.vue?vue&type=template&id=edaa9710&"
import script from "./PptShape.vue?vue&type=script&lang=js&"
export * from "./PptShape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/PptShape.vue"
export default component.exports